import React, { useEffect, useState } from "react";
import { Avatar, List, Space, Typography, Card } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { CALL_API } from "common/API";
import { useSelector } from "react-redux";
import { getClientid } from "redux/selectors";
import { STATUS_CODE } from "common/Constants";

const { Title, Text } = Typography;

const Wrapper = styled.div`
  .ant-card {
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
    border-radius: 5px;
  }
  .ant-list {
    height: 200px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  .ant-list-item-meta {
    display: flex;
    flex: 1 1;
    align-items: center;
    max-width: 100%;
  }
`;

const getInitials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0].toUpperCase())
    .join("");

export default function BirthdaySpotLight() {
  const { t } = useTranslation();
  const clientId = useSelector(getClientid);

  const [birthdayData, setBirthdayData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBirthdays = async () => {
    try {
      setLoading(true);
      const { code, birthdayList } = await CALL_API(`chat`, "post", {
        action: "getBirthdayList",
        clientId,
      });

      if (code === STATUS_CODE.SUCCESS) {
        const formatted = (birthdayList || [])
          // Active employees only - exited employees have a statusid other than "1"
          .filter((item) => String(item?.statusid) === "1")
          .map((item) => ({
            id: item.employeeid,
            userid: item.userid,
            name: item.fullname,
            role: item.designation || item.jobtitle || item.employeeid,
            avatar: item.profileurl || null, // no more ui-avatars.com fallback
            employeeId: item.employeeid,
          }));
        setBirthdayData(formatted);
      }
    } catch (err) {
      console.error("Birthday API error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBirthdays();
  }, []);

  return (
    <Wrapper>
      <Card>
        <div className="header">
          <Title level={5}>
            <Text strong>{t("Today's Birthday Spotlight")}</Text>
          </Title>
        </div>

        <List
          loading={loading}
          dataSource={birthdayData}
          itemLayout="horizontal"
          style={{ maxHeight: 350, overflowY: "auto", marginTop: 10 }}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={
                  item.avatar ? (
                    <Avatar src={item.avatar} size={48} />
                  ) : (
                    <Avatar
                      size={48}
                      style={{
                        backgroundColor: "#2D53DA",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {getInitials(item.name)}
                    </Avatar>
                  )
                }
                title={<Text strong>{item.name}</Text>}
                description={
                  <Space direction="vertical" size={4}>
                    <Text type="secondary">{item.role}</Text>
                  </Space>
                }
              />
            </List.Item>
          )}
        />
      </Card>
    </Wrapper>
  );
}